import { ComponentType, useEffect, useState } from "react";
import { AppUser } from "../../models/user/user";
import userService from "../../services/UserService/UserService";

export type UserData = {
  appUser: AppUser | null | undefined;
};

function withAppUserData<P>(Component: ComponentType<P & UserData>) {
  return ({ ...props }: P) => {
    const [appUser, setAppUser] = useState<AppUser | null | undefined>(
      undefined
    );

    useEffect(() => {
      userService.registerUserObserver((appUser: AppUser | null) => {
        setAppUser(appUser);
      });

      return () => userService.unregisterUserObserver();
    }, []);

    return <Component {...props} appUser={appUser} />;
  };
}

export default withAppUserData;
